// Shared Buy Box sub-tab bar: Settings, Agents, Reports, Saved, New matches.

import { Link, useLocation } from "wouter";

export const BUY_BOX_TABS = [
  { label: "Settings", href: "/app/buy-box/settings", testid: "tab-buy-box-settings" },
  { label: "Agents", href: "/app/buy-box/agents", testid: "tab-buy-box-agents" },
  { label: "Reports", href: "/app/buy-box/reports", testid: "tab-buy-box-reports" },
  { label: "Saved", href: "/app/buy-box/saved", testid: "tab-buy-box-saved" },
  { label: "New matches", href: "/app/buy-box/matches", testid: "tab-buy-box-matches" },
] as const;

export function BuyBoxSubnav() {
  const [location] = useLocation();
  return (
    <nav className="mb-6 flex gap-1 overflow-x-auto border-b border-gray-200" aria-label="Buy Box" data-testid="nav-buy-box-tabs">
      {BUY_BOX_TABS.map((t) => {
        const active = location === t.href || location.startsWith(`${t.href}/`);
        return (
          <Link key={t.href} href={t.href}>
            <span
              className={`-mb-px inline-block cursor-pointer whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium ${
                active ? "border-blue-600 text-blue-700" : "border-transparent text-gray-500 hover:text-gray-800"
              }`}
              aria-current={active ? "page" : undefined}
              data-testid={t.testid}
            >
              {t.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
